import React from "react";
import funcionamiento from "../../assets/funcionamiento.png";
import robot1 from "../../assets/robot1.png";

const Section4 = () => {

    return (
        <div className="relative bg-[#e8f2f4] px-60 py-16 overflow-hidden">
            <div className="absolute inset-0 z-0">
                <img src={robot1} alt="Robot 1" className="absolute top-[50px] left-[50px] w-[50%] h-auto opacity-70" />
                <img src={robot1} alt="Robot 2" className="absolute bottom-[150px] right-[-50px] w-[50%] h-auto opacity-30" />
            </div>

            <div className="relative z-10 text-[#033d8e] font-bold text-5xl pb-20 text-center w-[60%] mb-10 mx-auto" style={{ textShadow: '0px 2px 5px rgba(0,0,0,0.3)' }}>
                MEU como agente receptor terciario y asesor financiero independiente
            </div>

            <img src={funcionamiento} alt="Funcionamiento" className="relative z-10 rounded-3xl w-[50%] h-auto object-cover mx-auto" />
        </div>
    );
};

export default Section4;
